import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'timeUnixTransformer'
})
export class TimeUnixTransformerPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (typeof value === 'number' ) {
      return moment(value).utc().format('HH:mm');
    }
    return value;
  }

}
